module.exports = __webpack_public_path__ + "static/CrimsonText-Italic-69f39a51792dd7ac2982e02fc9ec8fed.ttf";